module.exports = __webpack_public_path__ + "statics/img/cate5-5@2x.ebdf5fc8.png";